
import { Vue, Component } from 'vue-property-decorator';
import ChangePasswordForm from '@/features/auth/components/changePassword/ChangePasswordForm.vue';

@Component({
  components: {
    ChangePasswordForm,
  },
})
export default class ChangePassword extends Vue {
  private errorMessage = '';
}
